// extracted by mini-css-extract-plugin
module.exports = {"overlay":"versionsModal__overlay___ZYEBg","modal":"versionsModal__modal___faTc7"};